<div class="table-container mat-mdc-card">

  @if(!notes){
  <div><code>Loading ...</code></div>
  }
  @else{
  <mat-form-field>
    <mat-label>{{ 'global.find' | translate}}</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'global.find-term' | translate}}..." #input>
  </mat-form-field>
  @for(row of notes; track $index){
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-subtitle>{{row.recordCreatedUserId}} on {{row.recordCreatedDate | date:'EEE, dd MMM yyyy hh:mm a'}}:</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <p>{{row.noteText}}</p>
      <p>
        <i>Attached to:</i>
        @for(attach of row.attachments;track $index){
        &nbsp;<a [routerLink]="`/main/form/${attach.formPct}/${attach.formId}/${attach.clientId}/${attach.visitId}/edit`">
          {{attach.formName}}
          @if(attach.isArchived === 'Y'){
          [Archived]
          }
        </a>
        }
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button matButton>{{ 'buttons.edit' | translate}}</button>
      <button matButton>{{ 'buttons.delete' | translate}}</button>
    </mat-card-actions>
  </mat-card>
  }
  @if(notes.length === 0){
  <mat-card class="no-data-found">
    <mat-card-content>
      {{ 'global.no-data' | translate}}
    </mat-card-content>
  </mat-card>
  }
  }
  <mat-paginator (page)="pageChanged($event)"
                 [length]="length"
                 [pageIndex]="pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 showFirstLastButtons
                 aria-label="Select page of elements">
  </mat-paginator>
</div>

